// src/stone/icons/Clock.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Clock = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 29",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M14 3.667c-5.891 0-10.667 4.775-10.667 10.666S8.109 25 14 25c5.89 0 10.666-4.776 10.666-10.667 0-5.89-4.775-10.666-10.666-10.666M1.333 14.333C1.333 7.338 7.004 1.666 14 1.666s12.666 5.672 12.666 12.667C26.666 21.33 20.996 27 14 27S1.333 21.329 1.333 14.333" }),
      /* @__PURE__ */ jsx("path", { d: "M14 6.333a1 1 0 0 1 1 1v6.382l4.114 2.057a1 1 0 1 1-.895 1.789l-4.666-2.333a1 1 0 0 1-.553-.895v-7a1 1 0 0 1 1-1" })
    ]
  }
);
var Clock_default = Clock;

export {
  Clock_default
};
